import React, { useEffect } from "react"
import { businessClaimPath } from "../../utils/businessClaim"

const trackEvent = (name, trackId) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, {
      event_category: "Business claims",
      event_label: String(trackId),
    })
  }
}

const BusinessClaimCard = ({ trackId, trackName }) => {
  useEffect(() => {
    trackEvent("business_claim_cta_view", trackId)
  }, [trackId])

  return (
    <aside className="my-12 border border-gray-200 bg-gray-50 p-8 md:flex md:items-center md:justify-between md:gap-8" aria-labelledby={`business-claim-${trackId}`}>
      <div>
        <p className="mb-2 text-sm font-bold uppercase tracking-widest text-indigo-700">Business owners</p>
        <h2 className="mb-2 text-2xl text-gray-900" id={`business-claim-${trackId}`}>Own or manage {trackName}?</h2>
        <p className="mb-0 text-gray-600">Claim this listing and help us verify your relationship with the business. Management tools will be added after we validate owner demand.</p>
      </div>
      <a
        className="mt-6 inline-flex shrink-0 items-center justify-center rounded bg-indigo-700 px-6 py-3 font-bold text-white no-underline hover:bg-indigo-800 md:mt-0"
        href={businessClaimPath(trackId)}
        onClick={() => trackEvent("business_claim_cta_click", trackId)}
      >
        Claim this business
      </a>
    </aside>
  )
}

export default BusinessClaimCard
